import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import DatePicker from "@mui/lab/DatePicker";
import { TextField } from "@mui/material";
import { Checkbox } from "@nextui-org/react";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./daterange-with-current.module.less";
export var DateRangeWithCurrent = function DateRangeWithCurrent(_ref) {
  var isCurrentProp = _ref.is_current,
      endDateProp = _ref.endDate,
      startDateProp = _ref.startDate,
      onChange = _ref.onChange;

  var _useState = useState(startDateProp),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = useState(endDateProp),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useState5 = useState(isCurrentProp !== null && isCurrentProp !== void 0 ? isCurrentProp : false),
      _useState6 = _slicedToArray(_useState5, 2),
      isCurrent = _useState6[0],
      setIsCurrent = _useState6[1];

  var maxStartDate = endDate; // future start dates are allowed

  var onChangeStartDate = useCallback(function (date) {
    setStartDate(date !== null && date !== void 0 ? date : undefined);
  }, []);
  var onChangeEndDate = useCallback(function (date) {
    setEndDate(date !== null && date !== void 0 ? date : undefined);
  }, []);
  var onIsCurrentChange = useCallback(function (e) {
    setIsCurrent(e.target.checked);
  }, []);
  useEffect(function () {
    if (!onChange) return;
    onChange({
      isCurrent: isCurrent,
      dates: [startDate, isCurrent ? undefined : endDate]
    });
  }, [startDate, endDate, isCurrent, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(DatePicker, {
    views: ["year", "month"],
    label: "Start date",
    maxDate: maxStartDate,
    value: startDate,
    clearable: true,
    allowSameDateSelection: true,
    onChange: onChangeStartDate,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        className: styles.textField,
        hiddenLabel: true,
        helperText: null
      }));
    }
  }), /*#__PURE__*/React.createElement(DatePicker, {
    disabled: isCurrent,
    views: ["year", "month"],
    label: "End date",
    minDate: startDate,
    value: endDate,
    clearable: true,
    allowSameDateSelection: true,
    onChange: onChangeEndDate,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        className: styles.textField,
        hiddenLabel: true,
        helperText: null
      }));
    }
  }), /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onIsCurrentChange,
    initialChecked: isCurrent,
    label: "Current"
  }));
};